import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'
import { NavLink } from 'react-router-dom'

export const Link = styled(NavLink)`
  color: rgb(140, 140, 140);
  font-weight: bold;

  &.active-main {
    color: #04bfe7;
    ${mq({
      borderBottom: ['none', 'none', 'solid 3px #04bfe7'],
    })}
  }

  &.active-submenu {
    color: #04bfe7;
    font-weight: bold;
  }
`
